import { FC, useEffect, useState } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import type { PlaceFilters as PlaceFiltersType } from '../../../../../types/place.types';
import PlaceFilters from '../PlaceFilters/PlaceFilters';
import CustomButton from '../../../../../common/CustomButton';

import styles from '../FlightFiltersModal/FlightFiltersModal.module.scss';

type PlaceFiltersModalProps = {
  open: boolean;
  onClose: () => void;
  filters: PlaceFiltersType;
  onApply: (next: PlaceFiltersType) => void;
};

const PlaceFiltersModal: FC<PlaceFiltersModalProps> = ({ open, onClose, filters, onApply }) => {
  const [draft, setDraft] = useState<PlaceFiltersType>(filters);

  useEffect(() => {
    if (open) {
      setDraft(filters);
    }
  }, [open, filters]);

  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(34, 43, 58, 0.35)' },
        },
      }}
      PaperProps={{
        className: styles.drawerPaper,
        elevation: 8,
      }}
    >
      <Box className={styles.header}>
        <Typography
          variant="h8Bold"
          className={styles.title}
        >
          Filters
        </Typography>
        <IconButton
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close filters"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className={styles.body}>
        <PlaceFilters
          filters={draft}
          onFiltersChange={setDraft}
        />
      </Box>

      <Box className={styles.footer}>
        <CustomButton
          variant="outlined"
          btnType="button"
          onClick={onClose}
          customClass={styles.footerBtn}
        >
          Cancel
        </CustomButton>
        <CustomButton
          variant="contained"
          btnType="button"
          onClick={handleApply}
          customClass={styles.footerBtn}
        >
          Apply filters
        </CustomButton>
      </Box>
    </Drawer>
  );
};

export default PlaceFiltersModal;
